import { injectGlobal } from 'styled-components';

import staticData from '../../static_data/all';

import _avertaWoff from '../../assets/font/averta.woff';
import _avertaWoff2 from '../../assets/font/averta.woff2';
import _avertaBoldWoff from '../../assets/font/averta-bold.woff';
import _avertaBoldWoff2 from '../../assets/font/averta-bold.woff2';
import _avertaLightWoff from '../../assets/font/averta-light.woff';
import _avertaLightWoff2 from '../../assets/font/averta-light.woff2';
import _avertaSemiBoldWoff from '../../assets/font/averta-semibold.woff';
import _avertaSemiBoldWoff2 from '../../assets/font/averta-semibold.woff2';
let avertaWoff = _avertaWoff;
let avertaWoff2 = _avertaWoff2;
let avertaBoldWoff = _avertaBoldWoff;
let avertaBoldWoff2 = _avertaBoldWoff2;
let avertaLightWoff = _avertaLightWoff;
let avertaLightWoff2 = _avertaLightWoff2;
let avertaSemiBoldWoff = _avertaSemiBoldWoff;
let avertaSemiBoldWoff2 = _avertaSemiBoldWoff2;

if (staticData.useStatic) {
    avertaWoff = 'https://s3.amazonaws.com/actionbutton.fonts/averta.woff';
    avertaWoff2 = 'https://s3.amazonaws.com/actionbutton.fonts/averta.woff2';
    avertaBoldWoff = 'https://s3.amazonaws.com/actionbutton.fonts/averta-bold.woff';
    avertaBoldWoff2 = 'https://s3.amazonaws.com/actionbutton.fonts/averta-bold.woff2';
    avertaLightWoff = 'https://s3.amazonaws.com/actionbutton.fonts/averta-light.woff';
    avertaLightWoff2 = 'https://s3.amazonaws.com/actionbutton.fonts/averta-light.woff2';
    avertaSemiBoldWoff =
        'https://s3.amazonaws.com/actionbutton.fonts/averta-semibold.woff';
    avertaSemiBoldWoff2 =
        'https://s3.amazonaws.com/actionbutton.fonts/averta-semibold.woff2';

    // static doesn't use the public/index.html, and hence doesn't load Lato
    if (typeof document !== 'undefined') {
        var link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        document.body.appendChild(link);
    }
}

// <link rel="preload" href="font.woff2" as="font" type="font/woff2" crossorigin>

function preloadFont(fontPath) {
    if (typeof document !== 'undefined') {
        var link = document.createElement('link');
        link.href = fontPath;
        link.rel = 'preload';
        link.as = 'font';
        link.type = 'font/woff2';
        document.body.appendChild(link);
    }
}

preloadFont(avertaWoff2);
preloadFont(avertaBoldWoff2);
preloadFont(avertaLightWoff2);
preloadFont(avertaSemiBoldWoff2);

injectGlobal`
  @font-face {
    font-family: 'Averta';
    src:
      url(${avertaLightWoff2}) format('woff2'),
      url(${avertaLightWoff}) format('woff');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Averta';
    src:
      url(${avertaWoff2}) format('woff2'),
      url(${avertaWoff}) format('woff');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Averta';
    src:
      url(${avertaSemiBoldWoff2}) format('woff2'),
      url(${avertaSemiBoldWoff}) format('woff');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'Averta';
    src:
      url(${avertaBoldWoff2}) format('woff2'),
      url(${avertaBoldWoff}) format('woff');
    font-weight: 700;
    font-style: normal;
  }

  h3 {
    font-weight: 400;
    margin: 0.5em 0;
  }

  p {
    margin: 0 0 1em;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;

    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
    font-smooth: always;

    min-height: 0;
    min-width: 0;
  }

  body {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }

  #root {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;

    & > div {
      flex: 1;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/containers/Widget/Widget.styles.js